import LuckyWheelContainer from '@components/LuckyWheel/LuckyWheelContainer';
import { useLuckyWheelCampaignDetailsQuery } from '@hooks/luckywheel/luckyWheel.gql.generated';
import { LoadingContainer } from '@sharedComponents';

import s from './LuckyWheelCampaign.module.less';
import { truncateText } from '@utils/formatter';
import { compareDate } from '@utils/datetime';
import { useTranslation } from 'next-i18next';

interface LuckyWheelCampaignProps {
  id: string;
  setVisible?: React.Dispatch<React.SetStateAction<boolean>>;
}

export default function LuckyWheelCampaign(props: LuckyWheelCampaignProps) {
  const { t: tLayout } = useTranslation('layout');

  const { id, setVisible } = props;

  const { data: luckyWheelCampaignDetailsData, loading: luckyWheelCampaignDetailsLoading } =
    useLuckyWheelCampaignDetailsQuery({
      variables: {
        id,
      },
      fetchPolicy: 'no-cache',
    });

  const luckyWheelCampaignDetails = luckyWheelCampaignDetailsData?.giftCampaignDetails;

  if (!luckyWheelCampaignDetails) return null;

  if (luckyWheelCampaignDetailsLoading) return <LoadingContainer />;

  const achievedRewards = luckyWheelCampaignDetails.achievedPrizes || [];

  const noMoreSpin = luckyWheelCampaignDetails.remainingTurns === 0;
  const showBuyMore = noMoreSpin && compareDate(luckyWheelCampaignDetails.toDate, new Date()) >= 0;

  return (
    <div className={s.luckyWheelCampaignRoot}>
      <div className={s.campaign}>
        <div className={s.titleSpin}>
          {tLayout('spin.remaining_spin')}
          <p>{luckyWheelCampaignDetails.remainingTurns}</p>
        </div>
        <div className={s.titleCampaign}>
          <a>{luckyWheelCampaignDetails.campaignName}</a>
        </div>
        <div className={s.titleSpin}>
          {tLayout('spin.total_spin')}
          <p>{luckyWheelCampaignDetails.totalTurns}</p>
        </div>
      </div>

      <div className={s.luckyWheel}>
        <LuckyWheelContainer
          campaignId={id}
          showBuyMore={showBuyMore}
          noMoreSpin={noMoreSpin}
          setVisible={setVisible}
        />
      </div>

      <div className={s.achievedRewards}>
        <div className={s.achievedRewardItemHeader}>
          <p>{tLayout('spin.bonus_prize')}</p>
          <p>{tLayout('spin.number_of_prizes')}</p>
        </div>
        {achievedRewards.map(
          reward =>
            reward.achievedQuantity > 0 && (
              <div key={reward.id} className={s.achievedRewardItem}>
                <p className={s.achievedrewardName}>{truncateText(reward.nameDetail, 60)}</p>
                <p className={s.achievedRewardQuantity}>{reward.achievedQuantity}</p>
              </div>
            ),
        )}
      </div>
    </div>
  );
}
